module.exports = __webpack_public_path__ + "assets/img/2807.4fec3b43.png";